import FilterItem from "./FilterItem";
import { SnapshotIn } from "mobx-state-tree";

const EmployeeType = FilterItem.named("EmployeeType");

export default EmployeeType;
export interface IEmployeeTypeSnapshotIn extends SnapshotIn<typeof EmployeeType> {}
